import { TFilterTreeSelect } from '@/common/components/redesigned/Filter/types/filter';
import { MenuModes } from '@/common/components/redesigned/TreeMultiselect/types';
import { getYearMonthTree } from '@/common/utils/options';

export const yearMonthPeriodTreeFilterConfig: TFilterTreeSelect = {
  type: 'tree-select',
  label: 'Период',
  options: getYearMonthTree(2001),
  vModel: 'periods',
  required: true,
  menuMode: MenuModes.COMBINED_MODAL,
  levelEventsLabels: ['годы', 'месяцы'],
};
